import apiService from '@/services/api/api/store';
import benefitService from '@/services/api/benefit';
import courseService from '@/services/api/course';
import examService from '@/services/api/exam';
import router from '@/services/api/router';

export default {
  namespaced: true,
  modules: {
    api: apiService,
    benefit: benefitService,
    course: courseService,
    exam: examService,
    router
  },
};
